import React from 'react';

import { useMatchMedia } from '@betterment/js-runtime';
import { Box, ContentLayoutE } from '@betterment/style-closet-react';

import ClaimedRewardsCard from './ClaimedRewardsCard';
import InvitationListCard from './InvitationListCard';
import ReferAFriendInvitationCard from './ReferAFriendInvitationCard';
import { useReferralSenderOffer } from './ReferAFriendProvider';
import UnclaimedRewardCard from './UnclaimedRewardCard';

const AvailableRewardsPage: React.FC = () => {
  const isAtLeastMedium = useMatchMedia('atLeastMedium');
  const { senderOfferName } = useReferralSenderOffer();

  return (
    <ContentLayoutE>
      <ContentLayoutE.Slot1 width={[1, 1, 2 / 3]} mb={isAtLeastMedium ? '0' : '6'}>
        <UnclaimedRewardCard />
        <Box mt={senderOfferName ? '9' : '0'}>
          <ClaimedRewardsCard />
        </Box>
      </ContentLayoutE.Slot1>
      <ContentLayoutE.Slot2 width={[1, 1, 1 / 3]}>
        <Box mb={isAtLeastMedium ? '9' : '6'}>
          <ReferAFriendInvitationCard />
        </Box>
        <InvitationListCard />
      </ContentLayoutE.Slot2>
    </ContentLayoutE>
  );
};

export default AvailableRewardsPage;
